import { useManagerHierarchyContext } from '../../contexts/ManagerHierarchyContext';
import { writeManagerSelection } from '../../utils/managerAccess';
import AnalyticsBreadcrumbNav from '../analytics/AnalyticsBreadcrumbNav';

function ManagerAnalyticsSidebarNav() {
  const hierarchy = useManagerHierarchyContext();
  return (
    <AnalyticsBreadcrumbNav
      hierarchy={hierarchy}
      basePath="/manager"
      writeSelection={writeManagerSelection}
      showUserLevel={false}
    />
  );
}

export default ManagerAnalyticsSidebarNav;
